<script>
import selectedProductsComponent from '../selected_products/selected_products.vue';

export default {
  data() {
    return {
      fbm_label: null,
      fbm_label_link: null,
      fbm_label_name: null,
      client_comment: '',
      validators: {
        fbm_label: {
          valid: null,
          validator: 'fbm_label',
          valid_size: null,
        },
      },
    };
  },
  components: {
    selected_products_component: selectedProductsComponent,
  },
  computed: {
    selectedProducts() {
      return this.$store.getters.getSelectedProducts;
    },
    goodConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => {
        const good = item.filter((subItem) => subItem.condition === 0);

        return good.length === 0 ? good.length : good
          .reduce((sum, current) => sum + Number(current.selected_quantity), 0);
      });
    },

    attentionConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => (
        item.filter((subItem) => subItem.condition === 2).length
      ));
    },

    badConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => (
        item.filter((subItem) => subItem.condition === 1).length
      ));
    },

    isButtonActive() {
      const isInvalid = this.selectedProducts
        .map((item) => item.filter((subItem) => subItem.valid === false).length === 0);

      const invalid = (element) => element === false;

      const validLabels = Object.keys(this.validators)
        .filter((key) => this.validators[key].valid === true).length === 0;

      return !isInvalid.some(invalid) && !validLabels;
    },
  },
  filters: {
    setLabelName(name) {
      const maxLength = 20;
      return name.length > maxLength ? `${name.slice(0, maxLength)}...` : name;
    },
  },
  methods: {
    loadLabelFile(event) {
      const data = new FormData();
      const file = event.target.files[0];

      if (!file || ((file.size / 1024) / 1024).toFixed(4) > 2) {
        this.validators.fbm_label.valid_size = false;
        this.validators.fbm_label.valid = null;

        this.fbm_label_link = null;
        return;
      }

      this.validators.fbm_label.valid_size = true;

      data.append('file', file);

      this.$store.dispatch('isload_label_file', {
        form: data,
        fbm_label: this.fbm_label,
        fbm_label_link: this.fbm_label_link,
        fbm_label_name: this.fbm_label_name,
      })
        .then((resp) => {
          if (resp.resp.status !== 201) {
            this.validators.fbm_label.valid = false;
            return;
          }

          this.fbm_label = resp.data.fbm_label;
          this.fbm_label_link = resp.data.fbm_label_link;
          this.fbm_label_name = resp.data.fbm_label_name;

          this.validators.fbm_label.valid = true;
        });
    },

    remove(subItem) {
      subItem.selected = false;
    },

    validate(product) {
      product.valid = (
        product.selected_quantity > 0 && product.selected_quantity <= product.quantity
      );
    },

    create() {
      const prepareData = {
        client_comment: this.client_comment,
        products: this.$store.getters.getSelectedProductsIds,
        fbm_label_id: this.fbm_label,
        fbm_label_link: this.fbm_label_link,
      };

      this.$store.commit('set_modal_inform', {
        type: 'inform',
        action: 'iscreate_fbm',
        action_data: JSON.stringify(prepareData),
        inform_message: 'Create FBM',
      });
    },
  },
};
</script>
<template src="./send_by_label.pug" lang="pug"></template>
